import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Box } from '@amzn/awsui-components-react';
import ToolsList from '../Tool/ToolsList';
import EditTool from '../Tool/EditTool';
import ViewRevision from '../Tool/ViewRevision';
import TestSuite from '../TestSuite/TestSuite';
import CreateTestSuite from '../TestSuite/CreateTestSuite';
import S3FilePreviewPage from '../quicksight/S3FilePreviewPage';
import UatSessions from '../Uat/UatSessions';
import UatSessionDetail from '../Uat/UatSessionDetail';
import UatSessionReview from '../Uat/UatSessionReview';
import ToolRefinementAgentChat from '../Agent/ToolRefinementAgentChat';
import TestCaseAgentChat from '../Agent/TestCaseAgentChat';
import TestSuiteConfigPage from '../ConfigGenerator/TestSuiteConfigPage';
import OnboardingWizardPage from '../Onboarding/OnboardingWizardPage';
import { ProtectedRoute } from 'src/auth/ProtectedRoute';

const AppRoutes: React.FC = () => {
  return (
    <Box padding="l">
      <Routes>
        {/* Accessible to all authenticated users (admin = full edit, uat = view only) */}
        <Route path="/" element={<ToolsList />} />
        <Route path="/tools" element={<ToolsList />} />
        <Route path="/tools/:toolId" element={<EditTool />} />
        <Route path="/tools/:toolId/version/:version/revision/:revision" element={<ViewRevision />} />
        <Route path="/testsuite" element={<TestSuite />} />
        <Route path="/testsuite/create" element={<CreateTestSuite />} />
        <Route path="/testsuite/config" element={<TestSuiteConfigPage />} />
        <Route path="/testsuites/preview" element={<S3FilePreviewPage />} />
        <Route path="/onboarding" element={<OnboardingWizardPage />} />

        {/* UAT screens - admin and uat both have full edit */}
        <Route path="/uat" element={<ProtectedRoute check={(p) => p.canAccessUat}><UatSessions /></ProtectedRoute>} />
        <Route path="/uat/sessions/:sessionId" element={<ProtectedRoute check={(p) => p.canAccessUat}><UatSessionDetail /></ProtectedRoute>} />
        <Route path="/uat/sessions/:sessionId/review" element={<ProtectedRoute check={(p) => p.canAccessUat}><UatSessionReview /></ProtectedRoute>} />

        {/* Admin only */}
        <Route path="/agent" element={<ProtectedRoute check={(p) => p.canAccessAgent}><ToolRefinementAgentChat /></ProtectedRoute>} />
        <Route path="/test-case-agent" element={<ProtectedRoute check={(p) => p.canAccessAgent}><TestCaseAgentChat /></ProtectedRoute>} />
      </Routes>
    </Box>
  );
};

export default AppRoutes;
